import { useEffect, useState } from 'react'

const useCheckMobile = () => {
  if (typeof window === `undefined`) {
    return
  }
  const [width, setWidth] = useState(window.innerWidth)
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  return width <= 767
}

export default useCheckMobile
